import Handler from "../Handler";

class TourneyBubbleBroadcastHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processTourneyBubbleBroadcast(receivedData);
  }
}

export default TourneyBubbleBroadcastHandler;

// BubbleBroadcast#{"tableId":"tableid","isITMBubble":false,"isFinalTableBubble":true,"message":"Hand-for-hand in progress. Please wait for other tables"}
